<h2
	class="{{ data.headerClass }}"
	mat-dialog-title
	style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem"
>
	{{ data.title }}
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div
		*ngIf="!allowHtmlEdit"
		class="p-8"
		fxLayout="row"
		fxLayoutAlign="{{ htmlContentLayout }}"
		fxLayoutGap="1rem"
	>
		<div [innerHTML]="data.body"></div>
	</div>

	<div
		*ngIf="allowHtmlEdit"
		class="p-8"
		fxLayout="row"
		fxLayoutAlign="center center"
		fxLayoutGap="1rem"
	>
		<quill-editor
			[(ngModel)]="htmlTemplate"
			[modules]="{ toolbar: quillToolbar }"
			[styles]="{ height: '400px' }"
			class="full-width"
			format="html"
			placeholder="Type email here..."
		></quill-editor>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div
		*ngIf="IS_NOT_EMPTY(data.confirmationText)"
		class="{{ data.confirmationTextClass }}"
		fxFlex="70"
	>
		{{ data.confirmationText }}
	</div>
	<div
		[ngClass]="{ 'm-t-1': IS_NOT_EMPTY(data.confirmationText) }"
		fxFlex
		fxLayoutAlign="end center"
	>
		<button
			(click)="confirm()"
			color="primary"
			mat-raised-button
			[ngStyle]="{ order: data.flipActions ? 2 : 1 }"
		>
			{{ data.ConfirmButtonText }}
		</button>
		<span
			(click)="closeDialog()"
			*ngIf="showCloseButton"
			style="color: blue"
			[ngStyle]="{ order: data.flipActions ? 1 : 2 }"
			class="link"
			[ngClass]="{
				'm-r-1': data.flipActions,
				'm-l-1': !data.flipActions,
				'primary-text': data.isCancelLinkPrimaryText,
			}"
		>
			{{ data.cancelButtonText }}
		</span>
	</div>
</mat-dialog-actions>
